import * as notifier from "../common/ErrorsNotification";
import * as meta from "../common/Metadata";
import {findActionsWithActionId} from "../common/Metadata";
import {QuestionFieldsEditor} from "./QuestionFieldsEditor";
import {find} from "../common/HasIDUtil";
import {translateMessage} from "../common/Translator";
import {NamaKendoWindow, NamaWindowBtnData} from "../views/NamaKendoWindow";
import {runCustomGuiPostAction} from "../actions/BaseDispatcher";

export class ActionHandler {
    constructor(id, idPrefix, metaData, performer) {
        /**
         * @type {namaTypes.GUIActionPlaceholder}
         */
        this.actionInfo = id;
        this.performer = performer;
        this.metaData = metaData;
        this.idPrefix = idPrefix;
    }

    /**
     *
     * @param presenter {EditPresenter | ListPresenter}
     */
    performAction(presenter) {
        let that = this;
        let metaData = that.metaData;
        let actionId = that.actionInfo.id;
        if (!that.actionInfo.customization)
            that.actionInfo.customization = {};
        //Screen modifier only set customization variables ??
        if (that.actionInfo.customization.guiPostActionsId) {
            runCustomGuiPostAction(that.actionInfo, presenter);
            return;
        }
        if (!that.actionInfo.isEmpty()) {
            that.performer.runCustomAction(that.actionInfo, presenter, metaData);
            return;
        }
        let action = findActionsWithActionId(actionId, metaData);
        if (!action) {
            notifier.showError(translateMessage("Could not find gui action definition with id: {0}", actionId));
            return;
        }
        if (action.mustBeSaved === true && presenter.isRecordNotSaved()) {
            notifier.showError(translateMessage("actionModifiedEntity"));
            return;
        }
        if (action.questions && action.questions.length > 0) {
            that.questionFieldsEditor = new QuestionFieldsEditor(that.idPrefix);
            that.questionFieldsEditor.setActionPerformer(that.performer);
            that.questionFieldsEditor.setNestActionPerform(that);
            let questionFields = [];
            for (let questionFieldId of action.questions) {
                let questionField = {};
                let questionMetadata = find(questionFieldId, action.questionsMetadata);
                if (questionMetadata == null) {
                    questionMetadata = meta.findFieldMetadata(questionFieldId, metaData);
                }
                if (questionMetadata == null) {
                    notifier.showError(translateMessage("Could not find question metada for {0} in action {1}", questionField, that.actionInfo.id));
                    continue;
                }
                questionField.metaData = questionMetadata;
                questionField.id = questionFieldId;
                questionFields.push(questionField);
            }
            if (questionFields && questionFields.length) {
                if (!action.actionInitializerClassName)
                    that.performActionWithQuestions(actionId, metaData, presenter, questionFields, action);
                else
                    that.performer.calcDefaultsOf(that.actionInfo.getId(), questionFields, (defaults) => that.performActionWithQuestions(actionId, metaData, presenter, questionFields, action, defaults), presenter, metaData, action);
            }
        } else {
            that.performer.performAction(that.actionInfo.id, [], metaData, presenter);
        }
    }

    performActionWithQuestions(actionId, metaData, presenter, questionFields, action, defaults) {
        let that = this;
        let window = new NamaKendoWindow(actionId, new NamaWindowBtnData("ok", () => {
            that.performer.performAction(that.actionInfo.getId(), that.questionFieldsEditor.getQuestionFields(), metaData, presenter);
            window.closeWindow();
        }), new NamaWindowBtnData("cancel"));
        window.relatedPresenter = presenter;
        that.questionFieldsEditor.edit(questionFields, defaults, null, action, window, window, presenter);
        window.showWindow();
    }
}


